import PropTypes from 'prop-types';
import React from 'react';
import {
  getBiToken,
  getCompId,
  getInstanceId,
  getPlayerVersion,
  getSessionId,
  getSiteOwnerId,
  getVisitorId,
} from '../../services';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {BiLogger, initLogger} from '../../services/biLogger/biLogger';
import {getArtifactsVersions} from '../../services/env/getWindowVersion/getWindowVersion';

export const BiContext = React.createContext<BiLogger | null>(null);

interface IState {
  biLogger: BiLogger;
}

class BiProvider extends React.Component<{children?: React.ReactNode}, IState> {
  static propTypes = {
    children: PropTypes.node,
    albumId: PropTypes.string.isRequired,
    trackId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  constructor(props) {
    super(props);
    this.state = {
      biLogger: initLogger({
        compId: getCompId(),
        playerVersion: getPlayerVersion(),
        sessionId: getSessionId(),
        artifactVersion: getArtifactsVersions(),
        albumId: props.albumId,
        isOwner: getVisitorId() === getSiteOwnerId(),
        schema: BI_SCHEMA,
      }),
    };
  }

  render() {
    return <BiContext.Provider value={this.state.biLogger}>{this.props.children}</BiContext.Provider>;
  }
}

export {BiProvider};
